import '.d{display:flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.bu{height:100vh;}.ssr-plugin'
import '.ad{flex-grow:1;}.ssr-plugin'
import '.a4{min-width:0px;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.fe{margin-top:2rem;}.ssr-plugin'
import '.d5{min-height:0px;}.ssr-plugin'
import '.bz{overflow-y:auto;}.ssr-plugin'
import '.g6{max-width:60rem;}.ssr-plugin'
import '.g7{margin-left:auto;}.ssr-plugin'
import '.g8{margin-right:auto;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'
import Column from '@app/components/layout/Column'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Column alignItems="stretch">
        <div className="d s v bu"
          style={{
            padding: isMobile ? '0rem' : '1.5rem',
            gap: isMobile ? 0 : '5rem',}}
        >
          <InitiativeSideBar />
          <div className="ad a4 d e"
          >
            <DashboardNavBar
              initiativeDashboard={true}
              style={{ backgroundColor: 'var(--palette-white)' }}
            />
            <div className="n d e fe ad d5 bz g6 g7 g8"
              style={{
                gap: gap,
                paddingInline: isMobile ? '1rem' : 0,}}
            >
              {children}
            </div>
          </div>
        </div>
      </Column>
    </ClientOnly>
  )
}
